import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Button, Row, Col, Form as BootstrapForm } from "react-bootstrap";
import { CloudUpload } from "@mui/icons-material";
import { motion } from "framer-motion";
import toast from "react-hot-toast";
import { fetchAdminMeta, saveMeta } from "../../../../actions/metaActions";
import { clearMeta, clearError } from '../../../../slices/metaSlice'
const MetaForm = () => {
    const { page: id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { meta, loading, isMetaCreated, isMetaUpdated, error } =
        useSelector((state) => state.metaState);

    const [initialValues, setInitialValues] = useState({
        slug: "",
        headingTitle: "",
        title: "",
        metaDescription: "",
        keywords: "",
        canonicalUrl: "",
        robots: "index, follow",
    });

    /* Fetch meta for edit */
    useEffect(() => {
        if (id) dispatch(fetchAdminMeta(id));
    }, [dispatch, id]);

    /* Populate form on edit */
    useEffect(() => {
        
        if (meta?._id && id) {
            setInitialValues({
                slug: meta.slug || "",
                headingTitle: meta.headingTitle || "",
                title: meta.title || "",
                metaDescription: meta.metaDescription || "",
                keywords: meta.keywords || "",
                canonicalUrl: meta.canonicalUrl || "",
                robots: meta.robots || "index, follow",
            });
        }
    }, [meta, id]);

    useEffect(() => {
        if (isMetaCreated && id) {
            toast.success("Saved successfully!");
            dispatch(clearMeta());
            navigate("/admin/meta");
        }
        if (isMetaCreated && !id) {
            toast.success("Updated successfully!");
            dispatch(clearMeta());
            navigate("/admin/meta");
        }
        if (error) {
            toast.error(error);
            dispatch(clearError());
        }
    }, [isMetaCreated, id, error, dispatch, navigate]);

    /* Validation */
    const validationSchema = Yup.object({
        slug: Yup.string()
            .required("Slug is required"),
        headingTitle: Yup.string().required("H1 heading is required"),
        title: Yup.string().required("Meta title is required"),
        metaDescription: Yup.string().required("Meta description is required"),
        canonicalUrl: Yup.string().required("Canonical URL is required"),
    });

    /* Submit */
    const handleSubmit = (values) => {
        dispatch(saveMeta({ metaData: values, id }));

        // dispatch(
        //     saveMeta({
        //         ...values,
        //         id,
        //     })
        // );
    };

    return (
        <motion.div
            className="container py-4"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
        >
            <h4 className="fw-bold mb-4 text-center">
                Meta Settings
            </h4>

            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                <Form>
                    <Row className="g-3">

                        {/* Slug */}
                        <Col md={6}>
                            <BootstrapForm.Label>Slug *</BootstrapForm.Label>
                            <Field
                                name="slug"
                                className="form-control"
                                placeholder="home / about-us / spa-products"
                            />
                            <ErrorMessage name="slug" component="div" className="text-danger small" />
                        </Col>

                        {/* Robots */}
                        <Col md={6}>
                            <BootstrapForm.Label>Robots</BootstrapForm.Label>
                            <Field as="select" name="robots" className="form-control">
                                <option value="index, follow">index, follow</option>
                                <option value="noindex, follow">noindex, follow</option>
                                <option value="noindex, nofollow">noindex, nofollow</option>
                            </Field>
                        </Col>

                        {/* H1 */}
                        <Col md={12}>
                            <BootstrapForm.Label>Heading Title (H1) *</BootstrapForm.Label>
                            <Field name="headingTitle" className="form-control" />
                            <ErrorMessage name="headingTitle" component="div" className="text-danger small" />
                        </Col>

                        {/* Meta Title */}
                        <Col md={6}>
                            <BootstrapForm.Label>Meta Title *</BootstrapForm.Label>
                            <Field name="title" className="form-control" />
                            <ErrorMessage name="title" component="div" className="text-danger small" />
                        </Col>

                        {/* Canonical */}
                        <Col md={6}>
                            <BootstrapForm.Label>Canonical URL *</BootstrapForm.Label>
                            <Field
                                name="canonicalUrl"
                                className="form-control"
                                placeholder="https://spabrands.me/"
                            />
                            <ErrorMessage name="canonicalUrl" component="div" className="text-danger small" />
                        </Col>

                        {/* Description */}
                        <Col md={12}>
                            <BootstrapForm.Label>Meta Description *</BootstrapForm.Label>
                            <Field
                                as="textarea"
                                name="metaDescription"
                                rows={3}
                                className="form-control"
                            />
                            <ErrorMessage name="metaDescription" component="div" className="text-danger small" />
                        </Col>

                        {/* Keywords */}
                        <Col md={12}>
                            <BootstrapForm.Label>Meta Keywords</BootstrapForm.Label>
                            <Field name="keywords" className="form-control" />
                        </Col>

                        {/* Submit */}
                        <Col md={12} className="text-center mt-4">
                            <Button type="submit" variant="success" disabled={loading}>
                                <CloudUpload className="me-2" />
                                {loading ? "Saving..." : "Save Meta"}
                            </Button>
                        </Col>

                    </Row>
                </Form>
            </Formik>
        </motion.div>
    );
};

export default MetaForm;
